export enum RoleEnum {
  User = 'user',
  Admin = 'admin',
  UserAdmin = 'useradmin',
  RolesAdmin = 'rolesadmin',
  ConfigurationAdmin = 'configurationadmin',
  RecipeRead = 'reciperead',
  RecipeWrite = 'recipewrite',
  RecipeAdmin = 'recipeadmin',
  ConversionRead = 'conversionread',
  PurchaseOrderRead = 'purchaseorderread',
  PurchaseOrderWrite = 'purchaseorderwrite',
  TransactionRead = 'transactionread',
  TransactionWrite = 'transactionwrite',
  TransactionAdmin = 'transactionadmin',
  StockRead = 'stockread',
  StockWrite = 'stockwrite',
  SourceTransactionRead = 'sourcetransactionread',
  StockCountRead = 'stockcountread',
  StockCountWrite = 'stockcountwrite',
  StockLocationRead = 'stocklocationread',
  StockLocationWrite = 'stocklocationwrite',
  StockListRead = 'stocklistread',
  StockListWrite = 'stocklistwrite',
  StockCountScheduleRead = 'stockcountscheduleread',
  StockCountScheduleWrite = 'stockcountschedulewrite',
  StockCountAdmin = 'stockcountadmin',
  ItemRead = 'itemread',
  ReportRead = 'reportread',
  TransferWrite = 'transferwrite',
  TransferRead = 'transferread',
  NotificationWrite = 'notificationwrite',
  CategoryAdmin = 'categoryadmin',
  InvoiceReconciliationRead = 'invoicereconciliationread',
  InvoiceReconciliationWrite = 'invoicereconciliationwrite',
  InvoiceReconciliationAdmin = 'invoicereconciliationadmin',
  StockCountEmail = 'stockcountemail',
  AutomatedTasks = 'automatedtasks',
  StockCountDelete = 'stockcountdelete',
  StockCountNotCompletedEmail = 'stockcountnotcompletedemail',
  StockCountNotCompletedSummaryEmail = 'stockcountnotcompletedsummaryemail',
  PurchaseOrderNotCompletedEmail = 'purchaseordernotcompletedemail',
  PurchaseOrderNotCompletedSummaryEmail = 'purchaseordernotcompletedsummaryemail',
  PredictiveOrdering = 'predictiveordering',
  PurchaseOrderAdjustmentsWrite = 'purchaseorderadjustmentswrite',
  DailyWasteCheckSheetRead = 'dailywastechecksheetread',
  DailyWasteCheckSheetWrite = 'dailywastechecksheetwrite',
  MadeInStoreRead = 'madeinstoreread',
  MadeInStoreWrite = 'madeinstorewrite',
  CreateItemsAndRecipes = 'createitemsandrecipes',
  ManualTransactionCostPriceWrite = 'manualtransactioncostpricewrite',
  IncomingTransferWrite = 'incomingtransferwrite',
  OutgoingTransferWrite = 'outgoingtransferwrite',
  StockCountUomsRead = 'stockcountuomsread',
  StockCountUomsWrite = 'stockcountuomswrite',
  AIOrderingAdmin = 'aiorderingadmin',
  OrderAuditRead = 'orderauditread',
  OrderAdHocOrders = 'orderadhocorders',
  PARConfigurationRead = 'parconfigurationread',
  PARConfigurationWrite = 'parconfigurationwrite',
  PredictiveOrderingReportRead = 'predictiveorderingreportread',
  ForecastRead = 'forecastread',
  ForecastWrite = 'forecastwrite',
  AIOrderingStore = 'aiorderingstore',
  FinancialManagementRead = 'financialmanagementread',
  FinancialManagementWrite = 'financialmanagementwrite',
  GenerateScheduleAdmin = 'generatescheduleadmin',
  BarcodeManagementRead = 'barcodemanagementread',
  BarcodeManagementWrite = 'barcodemanagementwrite',
  POSMapping = 'posmapping',
  DoNotCountItemsWrite = 'donotcountitemswrite',
  AuditAdministrator = 'auditadministrator',
  AuditRead = 'auditread',
  TrainingAreaRead = 'trainingarearead',
  TrainingAreaWrite = 'trainingareawrite',
}
